(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-ana"] && !Shopify.designMode) return;
  try {
    
(() => {
 if (customElements.get('ana-gallery')) return;
 class AnaGallery extends HTMLElement {
  connectedCallback() {
   if(this.ready)return;this.ready=true;
   this.video=this.querySelector('[data-an-video]');this.cover=this.querySelector('[data-an-cover]');
   this.player=this.querySelector('[data-an-player]');this.playButton=this.querySelector('[data-an-play]');
   this.error=this.querySelector('[data-an-error]');this.buttons=[...this.querySelectorAll('[data-an-film]')];
   this.categories=[...this.querySelectorAll('[data-an-category]')];this.loaded=null;this.attempt=0;this.quality='4k';
   this.qualityButtons=[...this.querySelectorAll('[data-an-quality]')];
   this.qualityButtons.forEach(b=>b.addEventListener('click',()=>this.changeQuality(b.dataset.anQuality)));
   this.buttons.forEach(b=>{b.disabled=false;b.addEventListener('click',()=>this.select(b));});
   this.categories.forEach(b=>{b.disabled=false;b.addEventListener('click',()=>this.showCategory(b.dataset.anCategory));});
   this.showCategory(this.categories[0].dataset.anCategory,false);
   this.playButton.addEventListener('click',()=>this.play());
   this.video.addEventListener('playing',()=>{if(this.loaded!==this.current||this.video.hidden)return;this.loading(false);this.cover.hidden=true;this.error.hidden=true;this.playButton.hidden=true;});
   this.video.addEventListener('waiting',()=>{if(this.loaded===this.current&&!this.video.hidden&&!this.video.paused)this.loading(true);});
   this.video.addEventListener('canplay',()=>this.loading(false));
   this.video.addEventListener('pause',()=>this.loading(false));
   this.video.addEventListener('error',()=>{if(this.loaded===this.current&&!this.video.hidden){this.recover();this.querySelector('[data-an-quality-status]').textContent=this.quality==='4k'?this.dataset.qualityError:'';}});
   this.querySelector('.an-thumbs').addEventListener('keydown',event=>this.moveFocus(event,this.visibleButtons,'[data-an-film]'));
   this.querySelector('.an-categories').addEventListener('keydown',event=>this.moveFocus(event,this.categories,'[data-an-category]'));
   this.externalHandlers=[...this.closest('.an-page').querySelectorAll('[data-an-open-film]')].map(el=>{
    const handler=()=>{const b=this.buttons.find(x=>x.dataset.anFilm===el.dataset.anOpenFilm);if(b){this.select(b);this.player.scrollIntoView({block:'center',behavior:'instant'});}};
    el.addEventListener('click',handler);return[el,handler];
   });
  }
  moveFocus(event,items,selector){
   const i=items.indexOf(event.target.closest(selector));if(i<0)return;
   let next;if(event.key==='ArrowRight')next=(i+1)%items.length;
   if(event.key==='ArrowLeft')next=(i-1+items.length)%items.length;
   if(event.key==='Home')next=0;if(event.key==='End')next=items.length-1;
   if(next===undefined)return;event.preventDefault();items[next].focus();
  }
  showCategory(key,announce=true){
   if(this.category===key)return;
   const category=this.categories.find(b=>b.dataset.anCategory===key);if(!category)return;
   this.attempt++;this.video.pause();this.loading(false);this.category=key;this.querySelector('.an-thumbs').dataset.anChapter=key;
   this.visibleButtons=this.buttons.filter(b=>b.dataset.anGroup===key);
   this.buttons.forEach(b=>b.hidden=b.dataset.anGroup!==key);
   this.categories.forEach(b=>b.setAttribute('aria-pressed',String(b===category)));
   this.current=this.visibleButtons[0];this.video.hidden=true;this.video.controls=false;
   this.cover.src=this.current.dataset.anPoster;this.cover.alt=this.current.dataset.anTitle;this.cover.hidden=false;
   this.playButton.hidden=false;this.error.hidden=true;
   this.querySelector('[data-an-chapter-note]').textContent=category.dataset.anNote;
   this.updateMeta(announce);
  }
  updateMeta(announce=true){
   const b=this.current;this.buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===b)));
   this.querySelector('[data-an-title]').textContent=b.dataset.anTitle;
   this.querySelector('[data-an-description]').textContent=b.dataset.anDescription;
   this.querySelector('[data-an-tag]').textContent=b.dataset.anTag;
   const count=String(this.visibleButtons.indexOf(b)+1).padStart(2,'0')+' / '+String(this.visibleButtons.length).padStart(2,'0');
   this.querySelector('[data-an-count]').textContent=count;
   if(announce)this.querySelector('[data-an-status]').textContent=b.dataset.anTitle+' · '+count;
  }
  loading(active){this.querySelector('[data-an-loading]').hidden=!active;this.player.setAttribute('aria-busy',String(active));}
  recover(){this.loading(false);this.video.hidden=true;this.video.controls=false;this.cover.hidden=false;this.playButton.hidden=false;this.error.hidden=false;}
  source(){return this.quality==='4k'?this.current.dataset.anOriginal:this.video.canPlayType('application/vnd.apple.mpegurl')?this.current.dataset.anHls:this.current.dataset.anSrc;}
  changeQuality(key){
   if(!['auto','4k'].includes(key)||this.quality===key)return;
   const time=this.loaded===this.current?this.video.currentTime:0,wasPlaying=!this.video.paused&&!this.video.hidden;
   this.quality=key;this.qualityButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.anQuality===key)));
   this.querySelector('[data-an-quality-status]').textContent='';
   if(this.loaded===this.current&&!this.video.hidden)this.play(time,wasPlaying);else this.loaded=null;
  }
  play(resumeTime=0,shouldPlay=true){
   const attempt=++this.attempt;
   if(this.loaded!==this.current||this.video.getAttribute('src')!==this.source()){
    this.video.pause();this.cover.hidden=false;this.error.hidden=true;
    this.video.src=this.source();this.video.poster=this.current.dataset.anPoster;
    this.video.setAttribute('aria-label',this.current.dataset.anTitle);
    this.cover.src=this.current.dataset.anPoster;this.cover.alt=this.current.dataset.anTitle;
    this.video.load();this.loaded=this.current;
    if(resumeTime>0)this.video.addEventListener('loadedmetadata',()=>{if(attempt===this.attempt)this.video.currentTime=Math.min(resumeTime,Math.max(0,this.video.duration-.1));},{once:true});
   }
   this.video.hidden=false;this.video.controls=true;this.playButton.hidden=shouldPlay;this.error.hidden=true;
   this.querySelector('[data-an-quality-status]').textContent='';
   this.loading(shouldPlay&&this.video.readyState<3);
   if(shouldPlay)this.video.play()?.catch(()=>{if(attempt===this.attempt)this.recover();});
  }
  select(button){
   if(this.category!==button.dataset.anGroup)this.showCategory(button.dataset.anGroup,false);
   this.current=button;this.updateMeta();
   if(window.matchMedia('(max-width:750px)').matches)this.player.scrollIntoView({block:'center',behavior:'instant'});
   this.play();
  }
  disconnectedCallback(){this.video?.pause();this.externalHandlers?.forEach(([el,handler])=>el.removeEventListener('click',handler));this.ready=false;}
 }
 customElements.define('ana-gallery',AnaGallery);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-contact"] && !Shopify.designMode) return;
  try {
    

(() => {
  const key = '__consiglieriContactV1';
  if (window[key]) { window[key].mount(document); return; }
  const registry = new Map();
  function mount(scope) {
    const roots = [...scope.querySelectorAll('[data-cs-contact]')];
    if (scope.matches?.('[data-cs-contact]')) roots.unshift(scope);
    for (const root of roots) {
      if (registry.has(root)) continue;
      const controller = new AbortController();
      const options = {signal: controller.signal, passive: true};
      const sections = [...root.querySelectorAll('[data-cs-showroom]')];
      const links = [...root.querySelectorAll('.cx-city-link')];
      const nav = root.querySelector('.cx-city-nav');
      let header = null, frame = null;
      try { header = document.querySelector(root.dataset.headerSelector); } catch (_) {}
      function update() {
        frame = null;
        if (header) root.style.setProperty('--cx-sticky-top', `${Math.max(0,header.getBoundingClientRect().bottom)}px`);
        if (!sections.length) return;
        const line = nav.getBoundingClientRect().bottom + 80;
        let current = sections[0].id;
        for (const section of sections) if (section.getBoundingClientRect().top <= line) current = section.id;
        for (const link of links) {
          if (link.hash === `#${current}`) link.setAttribute('aria-current','location');
          else link.removeAttribute('aria-current');
        }
      }
      const schedule = () => { if (frame === null) frame = requestAnimationFrame(update); };
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) for (const link of root.querySelectorAll('[data-cs-booking]')) {
        const url = new URL(link.href,location.href);
        if (url.origin === location.origin) { url.searchParams.set('preview_theme_id',preview); link.href = url.href; }
      }
      root.addEventListener('click',event => { const wa = event.target.closest('[data-cs-whatsapp]'); if (!wa || !root.contains(wa)) return; (window.dataLayer = window.dataLayer || []).push({event:'contact_whatsapp_click', showroom: wa.dataset.csWhatsapp || 'unknown', cta_location:'contact_showroom'}); }, {signal: controller.signal});
      window.addEventListener('scroll',schedule,options);
      window.addEventListener('resize',schedule,options);
      header?.addEventListener('transitionend',schedule,options);
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
      if (header) observer?.observe(header);
      registry.set(root,() => {controller.abort();observer?.disconnect();if(frame!==null)cancelAnimationFrame(frame);registry.delete(root);});
      update();
    }
  }
  window[key] = {mount};
  document.addEventListener('shopify:section:load',event => mount(event.target));
  document.addEventListener('shopify:section:unload',event => {
    for (const [root,destroy] of [...registry]) if (root===event.target || event.target.contains(root)) destroy();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});
  else mount(document);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-donna-camicie"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope = document) => {
    const roots = scope.matches?.('[data-cs-donna-camicie]') ? [scope] : scope.querySelectorAll('[data-cs-donna-camicie]');
    roots.forEach(root => {
      if (root.dataset.ccReady) return;
      root.dataset.ccReady = 'true';
      const cards = [...root.querySelectorAll('[data-cc-model]')];
      const dialog = root.querySelector('[data-cc-dialog]');
      const dialogBody = root.querySelector('[data-cc-dialog-body]');
      const summary = root.querySelector('[data-cc-selection-summary]');
      let common = null;
      let unsubscribeCommon = null;
      let selectedKey = null;
      const syncCommon = snapshot => {
        if (!summary) return;
        const choices = snapshot.items.filter(item => item.type === 'direction' && item.source === 'camicie' && item.status === 'available');
        const chosen = choices.find(item => item.key === selectedKey) || choices[choices.length - 1];
        selectedKey = chosen?.key || null;
        summary.hidden = !chosen;
        const entry = chosen && common.resolve({ type: 'direction', key: chosen.key });
        summary.querySelector('[data-cc-selected-label]').textContent = entry?.labels[(document.documentElement.lang || '').startsWith('en') ? 'en' : 'ro'] || '';
      };
      const connectCommon = () => {
        const api = window.CSInspiration;
        if (common || !api?.ready || typeof api.resolve !== 'function') return;
        common = api;
        unsubscribeCommon = common.subscribe(syncCommon);
        syncCommon(common.get());
      };
      connectCommon();
      window.addEventListener('cs:inspiration-ready', connectCommon);
      const disconnectCommon = event => {
        if (event.target !== root && !event.target?.contains?.(root)) return;
        unsubscribeCommon?.();
        window.removeEventListener('cs:inspiration-ready', connectCommon);
        document.removeEventListener('shopify:section:unload', disconnectCommon);
      };
      document.addEventListener('shopify:section:unload', disconnectCommon);
      let previousFocus;
      let restoreOnClose = true;
      const openModel = (id, trigger) => {
        const card = cards.find(item => item.dataset.ccModel === id);
        const content = card?.querySelector('template');
        if (!content || !dialog || typeof dialog.showModal !== 'function') return;
        previousFocus = trigger;
        restoreOnClose = true;
        dialogBody.replaceChildren(content.content.cloneNode(true));
        dialog.showModal();
        dialog.scrollTop = 0;
        root.querySelector('[data-cc-close]').focus();
      };
      root.addEventListener('click', event => {
        const filter = event.target.closest('[data-cc-filter]');
        if (filter) {
          const value = filter.dataset.ccFilter;
          root.querySelectorAll('[data-cc-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
          cards.forEach(card => { card.hidden = value !== 'all' && card.dataset.ccExpression !== value; });
          root.querySelector('[data-cc-count]').textContent = String(cards.filter(card => !card.hidden).length);
          return;
        }
        const open = event.target.closest('[data-cc-open]');
        if (open) { openModel(open.dataset.ccOpen, open); return; }
        const close = event.target.closest('[data-cc-close]');
        if (close) { dialog.close(); return; }
        const clear = event.target.closest('[data-cc-clear]');
        if (clear) {
          if (common && selectedKey) common.remove({ type: 'direction', key: selectedKey });
          else if (summary) { summary.hidden = true; summary.querySelector('[data-cc-selected-label]').textContent = ''; }
          return;
        }
        const selection = event.target.closest('[data-cc-select]');
        if (selection) {
          event.preventDefault();
          if (common) {
            const key = 'camicie:model-' + selection.dataset.ccSelect;
            const result = common.add({ type: 'direction', key });
            if (!result?.ok) { if (dialog.open) dialog.close(); common.open(result?.reason || 'unavailable'); return; }
            selectedKey = key;
          }
          summary.hidden = false;
          summary.querySelector('[data-cc-selected-label]').textContent = selection.dataset.ccLabel;
          restoreOnClose = false;
          if (dialog.open) dialog.close();
          const target = document.getElementById('programare') || summary;
          requestAnimationFrame(() => {
            target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            const form = target.closest('form') || target.querySelector('form');
            const firstField = form?.querySelector('input:not([type=hidden]):not([disabled]),select:not([disabled]),textarea:not([disabled])');
            if (firstField) firstField.focus({ preventScroll: true });
            else { summary.setAttribute('tabindex','-1'); summary.focus({ preventScroll: true }); }
          });
        }
      });
      dialog?.addEventListener('click', event => {
        if (event.target === dialog) {
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }
      });
      dialog?.addEventListener('close', () => { if (restoreOnClose) previousFocus?.focus({ preventScroll: true }); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-donna-mayfair"] && !Shopify.designMode) return;
  try {
    
/* Source-choice only. Existing PDP / Mayfair controllers retain playback ownership. */
(function () {
  'use strict';
  if (window.csDonnaVideoQuality) return;
  var states = new WeakMap();
  var activeOriginal = null;
  function attach(video, options) {
    if (!video || !video.hasAttribute('data-cs-donna-quality')) return null;
    if (states.has(video)) return states.get(video);
    var opts = options || {}, listeners = [], timer = null;
    var resolved = false, failed = false, original = false, disposed = false, pending = false;
    var resumeAt = 0, generation = 0, fallingBack = false, sourcePausePending = false;
    var sources = Array.from(video.querySelectorAll('source')).map(function (s) {
      var url = s.getAttribute('src') || s.dataset.dnSrc || '';
      var encodedHeight = url.match(/(?:HD|SD)-(\d+)p-/);
      return { url: url, type: s.type || '', width: Number(s.dataset.width) || 0, height: Number(s.dataset.height) || (encodedHeight ? Number(encodedHeight[1]) : 0) };
    }).filter(function (s) { return s.url; });
    var adaptive = sources.find(function (s) { return /mpegurl/i.test(s.type) && video.canPlayType(s.type); });
    var standard = adaptive || sources.filter(function (s) { return /mp4/i.test(s.type); }).sort(function (a, b) { return b.height - a.height; })[0] || sources[0];
    var master = video.dataset.csMaster || '';
    if (!/^https:\/\/cdn\.shopify\.com\/videos\/c\/o\/v\/[a-f0-9]{32}\.mp4$/.test(master)) master = '';
    // Set the approved cover without loading or starting the video.
    var poster = video.dataset.csPoster;
    if (poster && /^https:\/\/cdn\.shopify\.com\//.test(poster)) {
      video.poster = poster;
      if (opts.posterElement) { opts.posterElement.removeAttribute('srcset'); opts.posterElement.src = poster; }
    }
    var stop = function () { clearTimeout(timer); timer = null; pending = false; if (activeOriginal === video) activeOriginal = null; };
    var allowed = function () { return !disposed && video.isConnected && !document.hidden && (!opts.canRetry || opts.canRetry()); };
    function listen(name, fn) { video.addEventListener(name, fn); listeners.push([name, fn]); }
    function setSource(url, useOriginal) {
      stop(); generation++;
      resumeAt = video.currentTime || resumeAt;
      if (opts.beforeSwitch) opts.beforeSwitch();
      sourcePausePending = !video.paused;
      original = useOriginal;
      video.dataset.csQuality = useOriginal ? 'original' : 'standard';
      video.src = url;
      video.load();
    }
    function fallback() {
      if (!original || failed || !standard || disposed) return false;
      failed = true;
      fallingBack = true;
      setSource(standard.url, false);
      var expected = generation;
      requestAnimationFrame(function () {
        fallingBack = false;
        if (expected === generation && allowed() && opts.retry) opts.retry();
      });
      return true;
    }
    function watch() {
      clearTimeout(timer); timer = null;
      if (!original || failed || !allowed() || (!pending && video.paused)) return;
      var expected = generation;
      timer = setTimeout(function () {
        timer = null;
        if (expected === generation && allowed() && (pending || !video.paused)) fallback();
      }, 6000);
    }
    function prepare() {
      if (resolved || disposed) return;
      resolved = true;
      if (!standard) return;
      var connection = navigator.connection;
      var width = Number(video.dataset.csOriginalWidth), height = Number(video.dataset.csOriginalHeight);
      var codec = video.dataset.csOriginalCodec || '';
      var standardWidth = Number(video.dataset.csStandardWidth) || Math.max.apply(Math, sources.map(function (s) { return s.width; })) || 606;
      var neededWidth = video.getBoundingClientRect().width * (window.devicePixelRatio || 1);
      // NetInfo downlink is capped/absent in common browsers: it is not a throughput promise.
      // Attempt one visible PDP master, with slow-network veto and progress-based fallback.
      var slowConnection = connection && (connection.saveData || /^(slow-2g|2g|3g)$/.test(connection.effectiveType || ''));
      var useOriginal = opts.allowOriginal !== false && master && width > standardWidth && height > 0 && codec &&
        video.canPlayType('video/mp4; codecs="' + codec + '"') && !slowConnection &&
        innerWidth >= 1000 && matchMedia('(pointer: fine)').matches && neededWidth > standardWidth * 1.2 &&
        (!activeOriginal || activeOriginal === video);
      setSource(useOriginal ? master : standard.url, Boolean(useOriginal));
    }
    listen('loadedmetadata', function () { if (resumeAt > 0 && Number.isFinite(video.duration)) { try { video.currentTime = Math.min(resumeAt, Math.max(0, video.duration - .05)); } catch (_) {} resumeAt = 0; } });
    listen('play', function () { if (original) { if (activeOriginal && activeOriginal !== video) fallback(); else activeOriginal = video; } });
    listen('playing', function () { pending = false; watch(); });
    listen('timeupdate', watch);
    listen('waiting', watch);
    listen('stalled', watch);
    listen('pause', stop);
    listen('error', function () { if (original) fallback(); });
    var api = {
      prepare: prepare,
      start: function () {
        prepare();
        var currentConnection = navigator.connection;
        var restrictedNow = currentConnection && (currentConnection.saveData || /^(slow-2g|2g|3g)$/.test(currentConnection.effectiveType || ''));
        if (original && standard && (restrictedNow || innerWidth < 1000 || !matchMedia('(pointer: fine)').matches)) {
          failed = true; setSource(standard.url, false);
        }
        if (original) {
          if (activeOriginal && activeOriginal !== video && standard) { failed = true; setSource(standard.url, false); }
          else activeOriginal = video;
        }
        pending = true; watch();
      },
      pause: stop,
      isFallingBack: function () { return fallingBack; },
      consumeSourcePause: function () { var value = sourcePausePending; sourcePausePending = false; return value; },
      destroy: function () { disposed = true; generation++; stop(); listeners.forEach(function (x) { video.removeEventListener(x[0], x[1]); }); states.delete(video); }
    };
    states.set(video, api);
    return api;
  }
  window.csDonnaVideoQuality = { attach: attach };
})();

(() => {
  const initialize = (scope = document) => {
    const roots = scope.matches?.('[data-mayfair]') ? [scope] : scope.querySelectorAll('[data-mayfair]');
    roots.forEach(root => {
      if (root.dataset.mfReady) return;
      root.dataset.mfReady = 'true';
      const cards = [...root.querySelectorAll('[data-mf-card]')];
      const filters = [...root.querySelectorAll('[data-mf-filter]')];
      const dialog = root.querySelector('[data-mf-dialog]');
      const dialogImage = root.querySelector('[data-mf-dialog-image]');
      const dialogCopy = root.querySelector('[data-mf-dialog-copy]');
      const dialogTitle = root.querySelector('[data-mf-dialog-title]');
      const tabs = [...root.querySelectorAll('[data-mf-tab]')];
      const panels = [...root.querySelectorAll('[data-mf-panel]')];
      const listeners = new AbortController();
      let previousFocus;
      let restoreFocus = true;
      const media = new Set();
      const ratios = new Map();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const playLabel = root.dataset.playLabel;
      const pauseLabel = root.dataset.pauseLabel;
      const desiredMedia = new Set(), manualMedia = new Set();
      let observer, mediaResize;
      let visibilityFrame = 0, disposed = false, pageHidden = false;
      const playAttempts = new WeakMap();
      const pendingPlays = new WeakMap();
      const pendingFrames = new WeakMap(), videoCleanups = new WeakMap();
      const positionMediaControl = item => {
        const video = item.querySelector('video'), image = item.querySelector('img');
        if (image && !item.dataset.videoReady && getComputedStyle(image).objectFit === 'cover') {
          item.style.setProperty('--mf-media-inset-x', '0px');
          item.style.setProperty('--mf-media-inset-y', '0px');
          return;
        }
        const width = video?.videoWidth || image?.naturalWidth, height = video?.videoHeight || image?.naturalHeight;
        if (!width || !height || !item.clientWidth || !item.clientHeight) return;
        const scale = Math.min(item.clientWidth / width, item.clientHeight / height);
        item.style.setProperty('--mf-media-inset-x', `${Math.max(0, (item.clientWidth - width * scale) / 2)}px`);
        item.style.setProperty('--mf-media-inset-y', `${Math.max(0, (item.clientHeight - height * scale) / 2)}px`);
      };
      const visibilityScore = item => {
        if (!item.isConnected || item.closest('[hidden]')) return 0;
        const rect = item.getBoundingClientRect();
        if (!rect.width || !rect.height) return 0;
        const viewport = window.visualViewport;
        const x = viewport?.offsetLeft || 0, y = viewport?.offsetTop || 0;
        const width = viewport?.width || window.innerWidth, height = viewport?.height || window.innerHeight;
        let left = Math.max(x, rect.left), right = Math.min(x + width, rect.right);
        let top = Math.max(y, rect.top), bottom = Math.min(y + height, rect.bottom);
        for (let parent = item.parentElement; parent && parent !== document.documentElement; parent = parent.parentElement) {
          const style = getComputedStyle(parent), bounds = parent.getBoundingClientRect();
          if (/^(auto|scroll|hidden|clip)$/.test(style.overflowX || style.overflow)) { left = Math.max(left, bounds.left); right = Math.min(right, bounds.right); }
          if (/^(auto|scroll|hidden|clip)$/.test(style.overflowY || style.overflow)) { top = Math.max(top, bounds.top); bottom = Math.min(bottom, bounds.bottom); }
        }
        return Math.max(0, right - left) * Math.max(0, bottom - top) / (Math.min(rect.width, width) * Math.min(rect.height, height));
      };
      const nearViewport = item => {
        if (!item.isConnected || item.closest('[hidden]')) return false;
        const rect = item.getBoundingClientRect(), viewport = window.visualViewport;
        const left = viewport?.offsetLeft || 0, top = viewport?.offsetTop || 0;
        const width = viewport?.width || window.innerWidth, height = viewport?.height || window.innerHeight;
        return rect.width > 0 && rect.height > 0 && rect.right > left && rect.left < left + width && rect.bottom > top - height && rect.top < top + 2 * height;
      };
      const canPlay = item => {
        if (disposed || pageHidden || document.hidden || !item.isConnected || item.dataset.manualPause || item.closest('[hidden]')) return false;
        if (dialog.open ? !dialog.contains(item) : dialog.contains(item)) return false;
        const score = visibilityScore(item);
        if (manualMedia.has(item)) return score > 0;
        return score >= .2 && !reducedMotion.matches && !navigator.connection?.saveData;
      };
      const isCurrentVideo = (item, video) => item.querySelector('video') === video;
      const cancelFrame = video => {
        const frame = video && pendingFrames.get(video);
        if (frame?.id !== undefined) video.cancelVideoFrameCallback?.(frame.id);
        if (video) pendingFrames.delete(video);
      };
      const revealFrame = (item, video, frame) => {
        if (pendingFrames.get(video) !== frame || !isCurrentVideo(item, video)) return;
        pendingFrames.delete(video);
        if (!desiredMedia.has(item) || !canPlay(item) || video.paused || video.readyState < 2 || !video.videoWidth || !video.videoHeight) return;
        item.dataset.videoReady = 'true';
        positionMediaControl(item);
      };
      const watchFrame = (item, video) => {
        if (!isCurrentVideo(item, video) || item.dataset.videoReady || pendingFrames.has(video) || video.paused || !desiredMedia.has(item) || !canPlay(item)) return;
        const frame = { time: video.currentTime };
        pendingFrames.set(video, frame);
        if (video.requestVideoFrameCallback) frame.id = video.requestVideoFrameCallback(() => revealFrame(item, video, frame));
      };
      const restoreCover = (item, video) => {
        cancelFrame(video);
        delete item.dataset.videoReady;
        positionMediaControl(item);
      };
      const pauseVideo = video => {
        if (!video) return;
        video.csDonnaQuality?.pause();
        cancelFrame(video);
        playAttempts.set(video, (playAttempts.get(video) || 0) + 1);
        pendingPlays.delete(video);
        video.autoplay = false;
        if (!video.paused) video.pause();
      };
      const pauseItem = (item, restorePoster = true) => {
        desiredMedia.delete(item);
        const video = item.querySelector('video');
        pauseVideo(video);
        if (restorePoster) restoreCover(item, video);
      };
      const pauseMedia = () => { media.forEach(item => pauseItem(item)); };
      const releaseVideo = item => {
        const video = item.querySelector('video');
        pauseItem(item);
        if (!video) return;
        videoCleanups.get(video)?.();
        videoCleanups.delete(video);
        video.remove();
        updateMediaControl(item, null);
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        video.load();
      };
      const updateMediaControl = (item, video) => {
        const button = item.querySelector('[data-mf-play]'), paused = !video || video.paused;
        button.querySelector('[data-mf-play-icon]').toggleAttribute('hidden', !paused);
        button.querySelector('[data-mf-pause-icon]').toggleAttribute('hidden', paused);
        button.setAttribute('aria-pressed', String(!paused));
        button.setAttribute('aria-label', `${paused ? playLabel : pauseLabel} · ${item.querySelector('img')?.alt || ''}`);
      };
      const mountVideo = item => {
        let video = item.querySelector('video');
        if (video) return video;
        const template = item.querySelector('[data-mf-video-template]');
        if (!template) return null;
        const fragment = document.importNode(template.content, true);
        video = fragment.querySelector('video');
        if (!video) return null;
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.autoplay = desiredMedia.has(item) && canPlay(item);
        video.controls = false;
        video.removeAttribute('controls');
        const videoListeners = new AbortController();
        video.csDonnaQuality = window.csDonnaVideoQuality.attach(video, {
          allowOriginal: false,
          canRetry: () => isCurrentVideo(item, video) && desiredMedia.has(item) && canPlay(item),
          beforeSwitch: () => { cancelFrame(video); pendingPlays.delete(video); delete item.dataset.videoReady; },
          retry: () => { if (isCurrentVideo(item, video)) playMedia(item); },
          posterElement: item.querySelector('img')
        });
        const cleanup = () => { video.csDonnaQuality?.destroy(); videoListeners.abort(); };
        listeners.signal.addEventListener('abort', cleanup, { once: true });
        videoCleanups.set(video, () => { cleanup(); listeners.signal.removeEventListener('abort', cleanup); });
        const updateState = () => updateMediaControl(item, video);
        video.addEventListener('loadeddata', () => { if (!isCurrentVideo(item, video)) return; positionMediaControl(item); scheduleVisibility(); }, { signal: videoListeners.signal });
        video.addEventListener('canplay', () => { if (isCurrentVideo(item, video)) scheduleVisibility(); }, { signal: videoListeners.signal });
        video.addEventListener('play', () => {
          if (!isCurrentVideo(item, video)) return;
          if (!desiredMedia.has(item) || !canPlay(item)) { pauseItem(item); updateState(); return; }
          delete item.dataset.autoplayBlocked;
          updateState();
        }, { signal: videoListeners.signal });
        video.addEventListener('playing', () => {
          if (!isCurrentVideo(item, video)) return;
          if (!desiredMedia.has(item) || !canPlay(item)) { pauseItem(item); updateState(); return; }
          watchFrame(item, video);
          updateState();
        }, { signal: videoListeners.signal });
        video.addEventListener('timeupdate', () => {
          if (!isCurrentVideo(item, video)) return;
          watchFrame(item, video);
          const frame = pendingFrames.get(video);
          if (!video.requestVideoFrameCallback && frame && video.currentTime !== frame.time) revealFrame(item, video, frame);
        }, { signal: videoListeners.signal });
        ['waiting', 'emptied'].forEach(type => video.addEventListener(type, () => {
          if (isCurrentVideo(item, video)) restoreCover(item, video);
        }, { signal: videoListeners.signal }));
        video.addEventListener('stalled', () => {
          if (isCurrentVideo(item, video) && video.readyState < 2) restoreCover(item, video);
        }, { signal: videoListeners.signal });
        video.addEventListener('pause', () => {
          if (!isCurrentVideo(item, video) || !video.paused) return;
          if (video.csDonnaQuality?.consumeSourcePause()) { updateState(); return; }
          cancelFrame(video);
          if (!item.dataset.manualPause) restoreCover(item, video);
          if (video.paused && pendingPlays.has(video)) {
            item.dataset.autoplayBlocked = 'true';
            pauseItem(item);
          }
          updateState();
        }, { signal: videoListeners.signal });
        video.addEventListener('error', () => { if (!isCurrentVideo(item, video) || video.csDonnaQuality?.isFallingBack()) return; item.dataset.autoplayBlocked = 'true'; pauseItem(item); updateState(); }, { signal: videoListeners.signal });
        item.insertBefore(fragment, item.querySelector('[data-mf-play]'));
        updateState();
        return video;
      };
      const playMedia = (item, manual = false) => {
        if (manual) { delete item.dataset.manualPause; delete item.dataset.autoplayBlocked; manualMedia.add(item); }
        if (!canPlay(item)) return;
        desiredMedia.add(item);
        const video = mountVideo(item);
        if (!video) return;
        video.csDonnaQuality?.prepare();
        video.autoplay = true;
        watchFrame(item, video);
        if (!video.paused || pendingPlays.has(video)) return;
        const attempt = (playAttempts.get(video) || 0) + 1;
        playAttempts.set(video, attempt);
        pendingPlays.set(video, attempt);
        const rejected = error => {
          if (!isCurrentVideo(item, video) || playAttempts.get(video) !== attempt) return;
          pendingPlays.delete(video);
          if (!item.isConnected || error?.name === 'AbortError') return;
          if (error?.name === 'NotAllowedError') { item.dataset.autoplayBlocked = 'true'; pauseItem(item); }
          updateMediaControl(item, video);
        };
        try {
          video.csDonnaQuality?.start();
          const pending = video.play();
          Promise.resolve(pending).then(() => {
            if (!isCurrentVideo(item, video)) return;
            if (!desiredMedia.has(item) || !canPlay(item)) { pauseItem(item); return; }
            if (playAttempts.get(video) !== attempt) return;
            pendingPlays.delete(video);
          }, rejected);
        } catch (error) { rejected(error); }
      };
      const chooseVisible = () => {
        if (disposed || pageHidden || document.hidden) { pauseMedia(); return; }
        media.forEach(item => {
          const visible = visibilityScore(item) > 0;
          if (!visible) { manualMedia.delete(item); if (nearViewport(item)) pauseItem(item); else releaseVideo(item); return; }
          if (canPlay(item) && !item.dataset.autoplayBlocked) playMedia(item);
          else pauseItem(item, !item.dataset.manualPause || !visible);
        });
      };
      const refreshVisibility = () => {
        if (disposed) return;
        media.forEach(item => {
          const score = visibilityScore(item);
          if ((ratios.get(item) || 0) === 0 && score > 0) delete item.dataset.autoplayBlocked;
          ratios.set(item, score);
        });
        chooseVisible();
      };
      const scheduleVisibility = () => {
        if (disposed || visibilityFrame) return;
        visibilityFrame = requestAnimationFrame(() => { visibilityFrame = 0; refreshVisibility(); });
      };
      const resetBlocked = () => { media.forEach(item => { delete item.dataset.autoplayBlocked; }); };
      const registerMedia = scope => {
        scope.querySelectorAll('[data-mf-media]').forEach(item => {
          if (media.has(item)) return;
          media.add(item);
          ratios.set(item, 0);
          item.querySelector('[data-mf-play]').hidden = false;
          updateMediaControl(item, item.querySelector('video'));
          positionMediaControl(item);
          item.querySelector('img')?.addEventListener('load', () => { positionMediaControl(item); scheduleVisibility(); }, { signal: listeners.signal });
          mediaResize?.observe(item);
          observer?.observe(item);
        });
        scheduleVisibility();
      };
      if ('IntersectionObserver' in window) observer = new IntersectionObserver(scheduleVisibility, { threshold: [0, .2, .45, .6, .8, 1] });
      if ('ResizeObserver' in window) mediaResize = new ResizeObserver(entries => { entries.forEach(entry => positionMediaControl(entry.target)); scheduleVisibility(); });
      window.addEventListener('scroll', scheduleVisibility, { passive: true, signal: listeners.signal });
      window.addEventListener('load', scheduleVisibility, { once: true, signal: listeners.signal });
      window.addEventListener('resize', () => { media.forEach(positionMediaControl); scheduleVisibility(); }, { signal: listeners.signal });
      window.visualViewport?.addEventListener('scroll', scheduleVisibility, { passive: true, signal: listeners.signal });
      window.visualViewport?.addEventListener('resize', scheduleVisibility, { signal: listeners.signal });
      registerMedia(root);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) pauseMedia();
        else { resetBlocked(); refreshVisibility(); }
      }, { signal: listeners.signal });
      window.addEventListener('pagehide', () => { pageHidden = true; pauseMedia(); }, { signal: listeners.signal });
      window.addEventListener('pageshow', () => { pageHidden = false; resetBlocked(); refreshVisibility(); }, { signal: listeners.signal });
      reducedMotion.addEventListener?.('change', refreshVisibility, { signal: listeners.signal });
      navigator.connection?.addEventListener?.('change', refreshVisibility, { signal: listeners.signal });
      const retryAfterInteraction = event => {
        if (!event.isTrusted || event.target.closest?.('[data-mf-play],input,textarea,select,form,[contenteditable]')) return;
        if ([...media].some(item => item.dataset.autoplayBlocked && visibilityScore(item) > 0)) { resetBlocked(); refreshVisibility(); }
      };
      document.addEventListener('touchend', retryAfterInteraction, { passive: true, signal: listeners.signal });
      document.addEventListener('click', retryAfterInteraction, { signal: listeners.signal });
      document.addEventListener('keydown', retryAfterInteraction, { signal: listeners.signal });
      const showFilter = value => {
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mfFilter === value)));
        cards.forEach(card => { card.hidden = value !== 'all' && card.dataset.category !== value; });
        root.querySelector('[data-mf-status]').textContent = `${cards.filter(card => !card.hidden).length} ${root.dataset.countLabel}`;
        chooseVisible();
      };
      if (cards.length && Number(root.querySelector('[data-mf-filters]').dataset.mfPages || 1) === 1 && (!root.querySelector('[data-mf-products]') || filters.length > 2)) {
        root.querySelector('[data-mf-filters]').hidden = false;
        filters.forEach(button => {
          if (button.dataset.mfFilter !== 'all' && !cards.some(card => card.dataset.category === button.dataset.mfFilter)) button.hidden = true;
        });
      }
      const selectTab = button => {
        tabs.forEach(tab => { const selected = tab === button; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; });
        panels.forEach(panel => { panel.hidden = panel.dataset.mfPanel !== button.dataset.mfTab; });
        chooseVisible();
      };
      if (tabs.length) {
        root.querySelector('[data-mf-tabs]').hidden = false;
        panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', root.querySelector(`[data-mf-tab="${panel.dataset.mfPanel}"]`).id);
          panel.tabIndex = 0;
        });
        selectTab(tabs[0]);
      }
      const openLook = summary => {
        if (!dialog?.showModal) return false;
        const card = summary.closest('[data-mf-card]');
        const sourceImage = card.querySelector('img');
        if (!sourceImage) return false;
        previousFocus = summary;
        restoreFocus = true;
        pauseMedia();
        dialogImage.querySelectorAll('[data-mf-media]').forEach(item => { releaseVideo(item); observer?.unobserve(item); mediaResize?.unobserve(item); media.delete(item); ratios.delete(item); desiredMedia.delete(item); manualMedia.delete(item); });
        const sourceMedia = card.querySelector('.mf-media');
        const photo = sourceMedia ? sourceMedia.cloneNode(true) : sourceImage.cloneNode(true);
        photo.querySelector?.('video')?.remove();
        delete photo.dataset.videoReady;
        delete photo.dataset.manualPause;
        delete photo.dataset.autoplayBlocked;
        const img = photo.matches('img') ? photo : photo.querySelector('img');
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'auto');
        img.sizes = '(max-width: 700px) calc(100vw - 20px), 500px';
        dialogImage.replaceChildren(photo);
        dialogTitle.textContent = card.querySelector('[data-mf-name]').textContent;
        dialogCopy.replaceChildren(card.querySelector('[data-mf-copy]').cloneNode(true));
        dialog.showModal();
        registerMedia(dialogImage);
        return true;
      };
      if (dialog?.showModal) cards.forEach(card => card.querySelector('[data-mf-open]')?.setAttribute('aria-haspopup', 'dialog'));
      root.addEventListener('click', event => {
        const play = event.target.closest('[data-mf-play]');
        if (play) {
          event.preventDefault();
          const item = play.closest('[data-mf-media]');
          const video = item.querySelector('video');
          if (video && (!video.paused || pendingPlays.has(video))) { item.dataset.manualPause = 'true'; manualMedia.delete(item); pauseItem(item, false); updateMediaControl(item, video); }
          else playMedia(item, true);
          return;
        }
        if (event.target.closest('video')) return;
        const filter = event.target.closest('[data-mf-filter]');
        if (filter) { showFilter(filter.dataset.mfFilter); return; }
        const tab = event.target.closest('[data-mf-tab]');
        if (tab) { selectTab(tab); return; }
        const summary = event.target.closest('[data-mf-open]');
        if (summary && openLook(summary)) { event.preventDefault(); return; }
        if (event.target.closest('[data-mf-close]')) dialog.close();
        const appointment = event.target.closest('a[href="#appointment"]');
        if (appointment && dialog.open && dialog.contains(appointment)) { restoreFocus = false; dialog.close(); }
      }, { signal: listeners.signal });
      root.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-mf-tab]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let index = tabs.indexOf(tab);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        selectTab(tabs[index]);
        tabs[index].focus();
      }, { signal: listeners.signal });
      dialog.addEventListener('close', () => {
        dialogImage.querySelectorAll('[data-mf-media]').forEach(item => { releaseVideo(item); observer?.unobserve(item); mediaResize?.unobserve(item); media.delete(item); ratios.delete(item); desiredMedia.delete(item); manualMedia.delete(item); });
        dialogImage.replaceChildren();
        chooseVisible();
        if (restoreFocus && previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      }, { signal: listeners.signal });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }, { signal: listeners.signal });
      root._mfCleanup = () => { disposed = true; if (visibilityFrame) cancelAnimationFrame(visibilityFrame); if (dialog.open) dialog.close(); media.forEach(releaseVideo); observer?.disconnect(); mediaResize?.disconnect(); listeners.abort(); delete root.dataset.mfReady; };
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target.matches?.('[data-mayfair]') ? event.target : event.target.querySelector('[data-mayfair]');
    root?._mfCleanup?.();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-home-seasonal-chapter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs-home-film')) {
  customElements.define('cs-home-film', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const button = this.querySelector('[data-film-toggle]');
      const template = this.querySelector('[data-film-template]');
      if (!button || !template?.content.querySelector('video')) return;
      const events = new AbortController();
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let video, pending = false, attempt = 0, frame = 0, disposed = false;
      let manuallyPaused = false, manualPlayback = false, blocked = false, previousVisibility = 0, pageHidden = false;
      const visibility = () => {
        if (!this.isConnected || this.closest('[hidden]')) return 0;
        const rect = this.getBoundingClientRect(), viewport = window.visualViewport;
        const left = viewport?.offsetLeft || 0, top = viewport?.offsetTop || 0;
        const width = viewport?.width || innerWidth, height = viewport?.height || innerHeight;
        if (!rect.width || !rect.height || !width || !height) return 0;
        const visibleWidth = Math.max(0, Math.min(rect.right, left + width) - Math.max(rect.left, left));
        const visibleHeight = Math.max(0, Math.min(rect.bottom, top + height) - Math.max(rect.top, top));
        return visibleWidth * visibleHeight / (Math.min(rect.width, width) * Math.min(rect.height, height));
      };
      const allowed = () => !disposed && !pageHidden && !document.hidden && !manuallyPaused && visibility() >= (manualPlayback ? .01 : .25) && (manualPlayback || !reducedMotion.matches && !navigator.connection?.saveData);
      const update = () => {
        const playing = video && !video.paused;
        button.setAttribute('aria-pressed', String(Boolean(playing)));
        button.setAttribute('aria-label', `${playing ? this.dataset.pauseLabel : this.dataset.playLabel} · ${this.dataset.filmTitle}`);
        button.querySelector('[data-film-play]').toggleAttribute('hidden', Boolean(playing));
        button.querySelector('[data-film-pause]').toggleAttribute('hidden', !playing);
      };
      const pause = () => {
        attempt += 1;
        pending = false;
        if (video) { video.autoplay = false; if (!video.paused) video.pause(); }
        update();
      };
      const mount = () => {
        if (video) return video;
        const fragment = template.content.cloneNode(true);
        video = fragment.querySelector('video');
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.loop = true;
        video.autoplay = false;
        video.controls = false;
        video.removeAttribute('controls');
        video.setAttribute('aria-hidden', 'true');
        video.addEventListener('loadeddata', () => { this.dataset.videoReady = 'true'; }, { signal: events.signal });
        video.addEventListener('play', () => { if (!allowed()) pause(); else { blocked = false; update(); } }, { signal: events.signal });
        video.addEventListener('pause', update, { signal: events.signal });
        video.addEventListener('error', () => { delete this.dataset.videoReady; blocked = true; pause(); }, { signal: events.signal });
        this.insertBefore(fragment, button);
        return video;
      };
      const play = () => {
        if (!allowed() || blocked) return;
        const currentVideo = mount();
        if (!currentVideo.paused || pending) return;
        const currentAttempt = ++attempt;
        pending = true;
        const rejected = error => {
          if (attempt !== currentAttempt || disposed) return;
          pending = false;
          if (error?.name !== 'AbortError') blocked = true;
          update();
        };
        try {
          Promise.resolve(currentVideo.play()).then(() => {
            if (disposed || !this.isConnected) { currentVideo.pause(); return; }
            if (attempt !== currentAttempt) { if (!allowed()) currentVideo.pause(); return; }
            pending = false;
            if (!allowed()) pause(); else update();
          }, rejected);
        } catch (error) { rejected(error); }
      };
      const refresh = () => {
        if (disposed) return;
        const score = visibility();
        if (score > 0 && previousVisibility === 0) blocked = false;
        previousVisibility = score;
        if (!score || pageHidden || document.hidden) manualPlayback = false;
        if (!allowed()) pause(); else play();
      };
      const schedule = () => {
        if (!frame && !disposed) frame = requestAnimationFrame(() => { frame = 0; refresh(); });
      };
      button.hidden = false;
      button.addEventListener('click', () => {
        if (video && (!video.paused || pending)) { manuallyPaused = true; manualPlayback = false; pause(); }
        else { manuallyPaused = false; manualPlayback = true; blocked = false; play(); }
      }, { signal: events.signal });
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(schedule, { threshold: [0, .25, .5, .75, 1] }) : null;
      observer?.observe(this);
      window.addEventListener('scroll', schedule, { passive: true, signal: events.signal });
      window.addEventListener('resize', schedule, { signal: events.signal });
      window.visualViewport?.addEventListener('scroll', schedule, { passive: true, signal: events.signal });
      window.visualViewport?.addEventListener('resize', schedule, { signal: events.signal });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) blocked = false; refresh(); }, { signal: events.signal });
      window.addEventListener('pagehide', () => { pageHidden = true; refresh(); }, { signal: events.signal });
      window.addEventListener('pageshow', () => { pageHidden = false; blocked = false; refresh(); }, { signal: events.signal });
      reducedMotion.addEventListener?.('change', refresh, { signal: events.signal });
      navigator.connection?.addEventListener?.('change', refresh, { signal: events.signal });
      this.addEventListener('pointerdown', event => {
        if (blocked && event.isTrusted && !event.target.closest('[data-film-toggle]')) { blocked = false; refresh(); }
      }, { passive: true, signal: events.signal });
      this.cleanup = () => {
        disposed = true;
        pause();
        events.abort();
        observer?.disconnect();
        if (frame) cancelAnimationFrame(frame);
        button.hidden = true;
        video?.remove();
        delete this.dataset.videoReady;
        this.cleanup = null;
      };
      update();
      schedule();
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-men-search"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs-men-search-hero')) {
  class CsMenSearchHero extends HTMLElement {
    connectedCallback() {
      this.listenerController?.abort();
      const controls = this.querySelector('.cs-look-switch');
      const image = this.querySelector(':scope > img');
      const caption = this.querySelector('[data-cs-look-caption]');
      const counter = this.querySelector('[data-cs-look-counter]');
      if (!controls || !image || !caption || !counter) return;
      const templates = new Map(Array.from(this.querySelectorAll('template[data-cs-look]'), (template) => [template.dataset.csLook, template]));
      const buttons = Array.from(controls.querySelectorAll('button[data-look]'));
      if (!buttons.every((button) => templates.get(button.dataset.look)?.content.querySelector('img'))) return;
      this.listenerController = new AbortController();
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-look]');
        if (!button || !controls.contains(button) || button.getAttribute('aria-pressed') === 'true') return;
        const template = templates.get(button.dataset.look);
        const source = template?.content.querySelector('img');
        const currentImage = this.querySelector(':scope > img');
        if (!source || !currentImage) return;
        const replacement = source.cloneNode(true);
        replacement.id = currentImage.id;
        replacement.dataset.look = button.dataset.look;
        replacement.loading = 'eager';
        replacement.fetchPriority = 'auto';
        currentImage.replaceWith(replacement);
        caption.textContent = template.dataset.csCaption;
        counter.textContent = template.dataset.csCounter;
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      }, { signal: this.listenerController.signal });
      this.setAttribute('data-cs-hero-ready', '');
      controls.hidden = false;
    }

    disconnectedCallback() {
      this.listenerController?.abort();
    }
  }

  customElements.define('cs-men-search-hero', CsMenSearchHero);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-showroom-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs-showroom-film')) {
  customElements.define('cs-showroom-film', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const button = this.querySelector('[data-film-toggle]');
      const video = this.querySelector('video');
      if (!button || !video) return;
      const events = new AbortController();
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let pending = false, attempt = 0, frame = 0, disposed = false;
      let manuallyPaused = false, manualPlayback = false, blocked = false, previousVisibility = 0, pageHidden = false;
      const visibility = () => {
        if (!this.isConnected || this.closest('[hidden]')) return 0;
        const rect = this.getBoundingClientRect(), viewport = window.visualViewport;
        const left = viewport?.offsetLeft || 0, top = viewport?.offsetTop || 0;
        const width = viewport?.width || innerWidth, height = viewport?.height || innerHeight;
        if (!rect.width || !rect.height || !width || !height) return 0;
        const visibleWidth = Math.max(0, Math.min(rect.right, left + width) - Math.max(rect.left, left));
        const visibleHeight = Math.max(0, Math.min(rect.bottom, top + height) - Math.max(rect.top, top));
        return visibleWidth * visibleHeight / (Math.min(rect.width, width) * Math.min(rect.height, height));
      };
      const allowed = () => !disposed && !pageHidden && !document.hidden && !manuallyPaused && visibility() >= (manualPlayback ? .01 : .25) && (manualPlayback || !reducedMotion.matches && !navigator.connection?.saveData);
      const update = () => {
        const playing = video && !video.paused;
        button.setAttribute('aria-pressed', String(Boolean(playing)));
        button.setAttribute('aria-label', `${playing ? this.dataset.pauseLabel : this.dataset.playLabel} · ${this.dataset.filmTitle}`);
        button.querySelector('[data-film-play]').toggleAttribute('hidden', Boolean(playing));
        button.querySelector('[data-film-pause]').toggleAttribute('hidden', !playing);
      };
      const pause = () => {
        attempt += 1;
        pending = false;
        if (video) { video.autoplay = false; if (!video.paused) video.pause(); }
        update();
      };
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      video.autoplay = false;
      video.controls = false;
      video.removeAttribute('controls');
      video.setAttribute('aria-hidden', 'true');
      video.addEventListener('play', () => { if (!allowed()) pause(); else { blocked = false; update(); } }, { signal: events.signal });
      video.addEventListener('pause', update, { signal: events.signal });
      video.addEventListener('error', () => { blocked = true; pause(); }, { signal: events.signal });
      const play = () => {
        if (!allowed() || blocked) return;
        const currentVideo = video;
        if (!currentVideo.paused || pending) return;
        const currentAttempt = ++attempt;
        pending = true;
        const rejected = error => {
          if (attempt !== currentAttempt || disposed) return;
          pending = false;
          if (error?.name !== 'AbortError') blocked = true;
          update();
        };
        try {
          Promise.resolve(currentVideo.play()).then(() => {
            if (disposed || !this.isConnected) { currentVideo.pause(); return; }
            if (attempt !== currentAttempt) { if (!allowed()) currentVideo.pause(); return; }
            pending = false;
            if (!allowed()) pause(); else update();
          }, rejected);
        } catch (error) { rejected(error); }
      };
      const refresh = () => {
        if (disposed) return;
        const score = visibility();
        if (score > 0 && previousVisibility === 0) blocked = false;
        previousVisibility = score;
        if (!score || pageHidden || document.hidden) manualPlayback = false;
        if (!allowed()) pause(); else play();
      };
      const schedule = () => {
        if (!frame && !disposed) frame = requestAnimationFrame(() => { frame = 0; refresh(); });
      };
      button.hidden = false;
      button.addEventListener('click', () => {
        if (button.getAttribute('aria-pressed') === 'true') { manuallyPaused = true; manualPlayback = false; pause(); }
        else { manuallyPaused = false; manualPlayback = true; blocked = false; play(); }
      }, { signal: events.signal });
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(schedule, { threshold: [0, .25, .5, .75, 1] }) : null;
      observer?.observe(this);
      window.addEventListener('scroll', schedule, { passive: true, signal: events.signal });
      window.addEventListener('resize', schedule, { signal: events.signal });
      window.visualViewport?.addEventListener('scroll', schedule, { passive: true, signal: events.signal });
      window.visualViewport?.addEventListener('resize', schedule, { signal: events.signal });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) blocked = false; refresh(); }, { signal: events.signal });
      window.addEventListener('pagehide', () => { pageHidden = true; refresh(); }, { signal: events.signal });
      window.addEventListener('pageshow', () => { pageHidden = false; blocked = false; refresh(); }, { signal: events.signal });
      reducedMotion.addEventListener?.('change', refresh, { signal: events.signal });
      navigator.connection?.addEventListener?.('change', refresh, { signal: events.signal });
      this.addEventListener('pointerdown', event => {
        if (blocked && event.isTrusted && !event.target.closest('[data-film-toggle]')) { blocked = false; refresh(); }
      }, { passive: true, signal: events.signal });
      this.cleanup = () => {
        disposed = true;
        pause();
        events.abort();
        observer?.disconnect();
        if (frame) cancelAnimationFrame(frame);
        button.hidden = true;
        video.controls = true;
        video.removeAttribute('aria-hidden');
        this.cleanup = null;
      };
      update();
      schedule();
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-wpt-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs-wpt-film')) {
  customElements.define('cs-wpt-film', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      if (!video) return;
      video.autoplay = false;
      video.pause();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const start = () => {
        video.autoplay = true;
        video.play().catch(() => {});
      };
      if (!('IntersectionObserver' in window)) { start(); return; }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          start();
        }
      }, { threshold: 0.25 });
      this.observer.observe(video);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs26-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  function presetOccasion() {
    // v3 (08.09): ocazia presetată de pagină (ex. jeans → 'other', afișată ca „Luxury Casual Wear”); codul rămâne în allowlist-ul contractului.
    const src = document.querySelector('.cs26[data-cs26-occasion]');
    const sel = document.querySelector('form[data-cs-lead-form] select[name="cs_ui_lead_occasion"]');
    if (!src || !sel || sel.value) return;
    const code = src.dataset.cs26Occasion;
    if (![...sel.options].some(o => o.value === code)) return;
    sel.value = code; sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function initialize(root = document) {
    presetOccasion();
    root.querySelectorAll('.cs26 .detail-tabs').forEach(list => {
      if (list.dataset.ready) return;
      list.dataset.ready = 'true';
      const tabs = [...list.querySelectorAll('[role="tab"]')];
      const activate = (tab, focus = false) => {
        tabs.forEach(t => {
          const active = tab === t;
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus();
      };
      list.addEventListener('click', e => { const t = e.target.closest('[role="tab"]'); if (t) activate(t); });
      list.addEventListener('keydown', e => {
        const i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        const next = e.key === 'ArrowRight' ? (i + 1) % tabs.length : e.key === 'ArrowLeft' ? (i + tabs.length - 1) % tabs.length : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : -1;
        if (next >= 0) { e.preventDefault(); activate(tabs[next], true); }
      });
    });
    root.querySelectorAll('.cs26 .film-screen').forEach(frame => {
      if (frame.dataset.ready) return;
      frame.dataset.ready = 'true';
      const video = frame.querySelector('video');
      const play = frame.querySelector('[data-cs26-film-play]');
      if (!video || !play) return;
      video.setAttribute('aria-label', frame.dataset.filmLabel);
      play.hidden = false;
      play.addEventListener('click', () => video.play().catch(() => { play.hidden = false; }));
      video.addEventListener('play', () => { play.hidden = true; });
      video.addEventListener('pause', () => { play.hidden = false; });
      video.addEventListener('ended', () => { play.hidden = false; });
      if (frame.dataset.cs26Autoplay === 'true') {
        // v3 (08.09): redare automată, mută, doar cât filmul e în ecran; refuzul browserului (Low Power etc.) lasă butonul Play.
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const allowed = () => !reduced.matches && !(navigator.connection && navigator.connection.saveData);
        let userPaused = false, visible = false;
        video.muted = true; video.loop = true; video.setAttribute('muted', '');
        const update = () => { if (visible && !document.hidden && !userPaused && allowed()) { video.play().catch(() => { play.hidden = false; }); } else if (!video.paused) { video.pause(); } };
        video.addEventListener('pause', () => { if (visible && !document.hidden) userPaused = true; });
        play.addEventListener('click', () => { userPaused = false; });
        video.addEventListener('play', () => { userPaused = false; });
        if ('IntersectionObserver' in window) { new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); }, { threshold: .35 }).observe(video); }
        else { visible = true; update(); }
        document.addEventListener('visibilitychange', update); reduced.addEventListener('change', update);
      }
    });
    root.querySelectorAll('.cs26 .coat-dialog').forEach(dialog => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('keydown', e => {
        if (e.key === 'Escape' && dialog.open) { e.preventDefault(); dialog.close(); }
      });
      dialog.addEventListener('click', e => {
        if (e.target !== dialog) return;
        const b = dialog.getBoundingClientRect();
        if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.body.classList.remove('cs26-dialog-open');
        if (!dialog._skipFocusRestore && dialog._opener?.isConnected) dialog._opener.focus({ preventScroll: true });
        dialog._skipFocusRestore = false;
      });
    });
    root.querySelectorAll('.cs26-collection').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      let selected = 'all', limit = Infinity; /* UX-01 (09.09.2026): no click-gated reveal — all cards of the page are visible */
      const cards = [...section.querySelectorAll('.existing-card')];
      const more = section.querySelector('[data-cs26-more]');
      const counter = section.querySelector('.collection-count');
      const suffix = counter.textContent.trim().replace(/^\d+\s*/, '');
      const update = () => {
        let count = 0;
        cards.forEach(card => {
          const match = selected === 'all' || card.dataset.type === selected;
          card.hidden = !match || count >= limit;
          if (match) count++;
        });
        counter.textContent = count + ' ' + suffix;
        more.hidden = true;
      };
      section.querySelectorAll('[data-cs26-filter]').forEach(button => button.addEventListener('click', () => {
        selected = button.dataset.cs26Filter;
        limit = Infinity; /* UX-01: filters never re-hide the list */
        section.querySelectorAll('[data-cs26-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        update();
      }));
      more.addEventListener('click', () => { limit = Infinity; update(); });
      update();
    });
  }
  document.addEventListener('click', e => {
    const open = e.target.closest('[data-cs26-dialog]');
    if (open) {
      const dialog = document.getElementById(open.dataset.cs26Dialog);
      if (!dialog) return;
      dialog._opener = open;
      dialog._skipFocusRestore = false;
      dialog.showModal();
      document.body.classList.add('cs26-dialog-open');
    }
    const close = e.target.closest('[data-cs26-close]');
    if (close) close.closest('dialog').close();
    const appointment = e.target.closest('[data-cs26-appointment]');
    if (appointment) {
      const dialog = appointment.closest('dialog');
      dialog._skipFocusRestore = true;
      dialog.close();
      const anchor = document.getElementById('appointment');
      if (anchor) {
        anchor.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        const form = anchor.closest('form') || anchor.parentElement.querySelector('form');
        form?.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true });
      }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', e => initialize(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('.coat-dialog[open]').forEach(dialog => {
      dialog._skipFocusRestore = true;
      dialog.close();
    });
    if (!document.querySelector('.coat-dialog[open]')) document.body.classList.remove('cs26-dialog-open');
  });
  document.addEventListener('shopify:block:select', e => {
    const panel = e.target.closest('.detail-panel');
    if (panel) document.getElementById(panel.getAttribute('aria-labelledby'))?.click();
  });
})();

/* Shared progressive enhancement. Uses the existing showroom field and its canonical values. */
(() => {
 const ro = document.documentElement.lang !== 'en' && !location.hostname.includes('consiglierimen.com');
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const names = {'București':'bucuresti','Cluj-Napoca':'cluj','Timișoara':'timisoara','Constanța':'constanta'};
 document.addEventListener('click', event => {
  const lineLink=event.target.closest('[data-lead-line]');
  if(lineLink){
   const line=document.querySelector('select[name="cs_ui_lead_line"],select[name="line"]');
   const value=lineLink.dataset.leadLine;
   const option=line&&[...line.options].find(o=>o.value===value||o.textContent.trim()==='Consiglieri '+value.toUpperCase());
   if(option){line.value=option.value;line.dispatchEvent(new Event('change',{bubbles:true}));}
  }
  const link = event.target.closest('[data-showroom], .shopify-section--contact .prose a[href="#appointment"]');
  if (!link) return;
  const value = link.dataset.showroom || names[link.textContent.trim()];
  if (!value) return;
  const select = document.querySelector('select[name="contact[showroom]"], select[name="showroom"]');
  if (!select || ![...select.options].some(option => option.value === value)) return;
  select.value = value;
  select.dispatchEvent(new Event('change', {bubbles:true}));
  select.focus({preventScroll:true});
 });
 function initialize(root=document) {
  root.querySelectorAll('.editorial-video').forEach(video => {
   if(video.dataset.initialized) return;
   video.dataset.initialized='true';
   const control=video.closest('[data-video-container], .card-image')?.querySelector('[data-video-toggle]');
   if(!control) return;
   let userPaused=false, userStarted=false, visible=false;
   const sync=()=>{
    control.setAttribute('aria-pressed',String(!video.paused));
    control.setAttribute('aria-label',video.paused ? (ro?'Redă filmul':'Play film') : (ro?'Pune filmul pe pauză':'Pause film'));
    control.innerHTML = video.paused ? '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m8 4 12 8-12 8Z" fill="currentColor"/></svg>' : '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 4v16M17 4v16" stroke="currentColor" stroke-width="3"/></svg>';
   };
   const update=()=>{
    const allowed=userStarted||(!reduced.matches&&!navigator.connection?.saveData);
    if(visible&&!document.hidden&&!userPaused&&allowed) video.play().catch(sync); else video.pause();
   };
   control.addEventListener('click',()=>{userPaused=!video.paused;userStarted=!userPaused;update();});
   video.addEventListener('play',sync);video.addEventListener('pause',sync);
   let observer;
   if('IntersectionObserver' in window){observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update();},{threshold:.25});observer.observe(video);}
   else {visible=true;update();}
   document.addEventListener('visibilitychange',update);reduced.addEventListener('change',update);
   video.cs26Cleanup=()=>{observer?.disconnect();document.removeEventListener('visibilitychange',update);reduced.removeEventListener('change',update);video.pause();};sync();
  });
 }
 initialize();document.addEventListener('shopify:section:load',e=>initialize(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.editorial-video').forEach(video=>video.cs26Cleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dn-shell"] && !Shopify.designMode) return;
  try {
    
(() => {
  const cleanups = [];
  function init() {
    const shell = document.querySelector('[data-dn-shell]');
    if (!shell || shell.dataset.ready) return;
    shell.dataset.ready = '1';
    const handlers = [];
    const on = (el, ev, fn, opts) => { if (!el) return; el.addEventListener(ev, fn, opts); handlers.push(() => el.removeEventListener(ev, fn, opts)); };
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 760px)');
    const anchorId = shell.dataset.formAnchor || 'programare';
    const formAnchor = document.getElementById(anchorId);
    const formSection = formAnchor ? formAnchor.closest('.shopify-section') : null;

    /* Local appointment CTAs (hero, sticky, dialog, announcement bar) land on the page's own form */
    const goToForm = (event) => {
      if (!formSection) return;
      if (event) event.preventDefault();
      formSection.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
      const heading = formSection.querySelector('.section-header .h2, h2, h3');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
    };
    document.querySelectorAll('[data-dn-appointment]').forEach(link => on(link, 'click', goToForm));
    document.querySelectorAll('.shopify-section--announcement-bar a[href*="programeaza"], .shopify-section--announcement-bar a[href*="schedule"]').forEach(link => {
      if (!formSection) return;
      link.setAttribute('href', '#' + anchorId);
      on(link, 'click', goToForm);
    });

    /* Galleries (one per page, but written generically) */
    document.querySelectorAll('[data-dn-gallery]').forEach(gallery => {
      const cards = [...gallery.querySelectorAll('[data-dn-card]')];
      const filters = [...gallery.querySelectorAll('[data-dn-filter]')];
      const filterWrap = gallery.querySelector('[data-dn-filters]');
      const moreWrap = gallery.querySelector('[data-dn-more]');
      const moreButton = gallery.querySelector('[data-dn-more-button]');
      const count = gallery.querySelector('[data-dn-count]');
      const shown = gallery.querySelector('[data-dn-shown]');
      const progress = gallery.querySelector('[data-dn-progress] span');
      const empty = gallery.querySelector('[data-dn-empty]');
      const initial = Infinity; /* UX-01 (09.09.2026): every card of the current native page is visible from the start — no click-gated reveal; further pages append via cs-listing */
      const labels = { one: gallery.dataset.labelOne || '{count}', many: gallery.dataset.labelMany || '{count}', shown: gallery.dataset.labelShown || '{shown} / {total}' };
      let selected = 'all';
      let limit = initial;
      const matching = () => cards.filter(card => selected === 'all' || card.dataset.category === selected);
      const update = () => {
        const list = matching();
        cards.forEach(card => { card.hidden = !list.includes(card) || list.indexOf(card) >= limit; });
        const visible = Math.min(limit, list.length);
        if (count) count.textContent = (list.length === 1 ? labels.one : labels.many).replace('{count}', list.length);
        if (moreWrap) moreWrap.hidden = list.length <= visible;
        if (shown) shown.textContent = labels.shown.replace('{shown}', visible).replace('{total}', list.length);
        if (progress) progress.style.width = (list.length ? visible / list.length * 100 : 0) + '%';
        if (empty) empty.hidden = list.length !== 0;
      };
      if (filterWrap) filterWrap.hidden = false;
      filters.forEach(button => on(button, 'click', () => {
        selected = button.dataset.dnFilter; limit = initial;
        filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        update();
      }));
      on(moreButton, 'click', () => {
        const firstNew = matching()[limit];
        limit = cards.length; update();
        if (firstNew) { const a = firstNew.querySelector('a'); if (a) a.focus({ preventScroll: true }); }
      });
      update();

      /* Dialog */
      if (shell.dataset.productNavigation === 'direct') return;
      const viewer = gallery.querySelector('[data-dn-viewer]');
      if (!viewer || typeof viewer.showModal !== 'function') return;
      const img = viewer.querySelector('[data-dn-viewer-image]');
      const title = viewer.querySelector('[data-dn-viewer-title]');
      const price = viewer.querySelector('[data-dn-viewer-price]');
      const product = viewer.querySelector('[data-dn-viewer-product]');
      const counter = viewer.querySelector('[data-dn-viewer-counter]');
      const prev = viewer.querySelector('[data-dn-viewer-prev]');
      const next = viewer.querySelector('[data-dn-viewer-next]');
      const appointment = viewer.querySelector('[data-dn-viewer-appointment]');
      let sequence = [], current = 0, opener = null;
      const render = () => {
        const card = sequence[current]; if (!card) return;
        img.src = card.dataset.image; img.alt = card.dataset.imageAlt || card.dataset.title + ' — Consiglieri DONNA';
        title.textContent = card.dataset.title;
        if (price) price.innerHTML = card.dataset.priceHtml || '';
        product.href = card.dataset.url;
        counter.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(sequence.length).padStart(2, '0');
        prev.disabled = sequence.length < 2; next.disabled = sequence.length < 2;
      };
      const open = (origin, source) => {
        const card = cards.find(c => c.dataset.productId && c.dataset.productId === origin.dataset.productId) || origin;
        sequence = matching(); if (!sequence.includes(card)) sequence = cards.includes(card) ? cards.slice() : [card];
        current = sequence.indexOf(card); opener = source; render();
        viewer.showModal(); document.body.classList.add('dn-modal-open');
        viewer.querySelector('[data-dn-viewer-close]').focus();
        document.dispatchEvent(new Event('dn:dialog-open'));
      };
      const advance = step => { current = (current + step + sequence.length) % sequence.length; render(); };
      document.querySelectorAll('[data-dn-card]').forEach(card => card.querySelectorAll('[data-dn-open]').forEach(link => on(link, 'click', event => {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); open(card, link);
      })));
      on(viewer.querySelector('[data-dn-viewer-close]'), 'click', () => viewer.close());
      on(prev, 'click', () => advance(-1)); on(next, 'click', () => advance(1));
      on(viewer, 'keydown', event => { if (event.key === 'ArrowLeft') { event.preventDefault(); advance(-1); } if (event.key === 'ArrowRight') { event.preventDefault(); advance(1); } });
      on(viewer, 'click', event => { if (event.target === viewer) { const r = viewer.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) viewer.close(); } });
      on(viewer, 'close', () => { document.body.classList.remove('dn-modal-open'); if (opener) opener.focus({ preventScroll: true }); });
      on(appointment, 'click', event => {
        event.preventDefault();
        const card = sequence[current];
        const context = document.querySelector('[data-dn-context]');
        if (context && card) { context.textContent = (context.dataset.label || '') + card.dataset.title; context.hidden = false; }
        viewer.close();
        requestAnimationFrame(() => goToForm());
      });
    });

    /* Context line inside the shared form (visual only — never part of the payload) */
    if (formSection && !formSection.querySelector('[data-dn-context]')) {
      const form = formSection.querySelector('form');
      const label = shell.dataset.contextLabel || (document.querySelector('[data-dn-gallery]') || {}).dataset?.contextLabel || '';
      if (form) { const p = document.createElement('p'); p.className = 'dn-context'; p.hidden = true; p.setAttribute('data-dn-context', ''); p.dataset.label = label; form.insertBefore(p, form.firstChild); }
    }

    /* Sticky CTA (mobile): after the intro, hidden over the form/footer and while the dialog is open */
    const sticky = document.querySelector('[data-dn-sticky]');
    const intro = document.querySelector('[data-dn-intro]');
    const footer = document.querySelector('.shopify-section--footer');
    let introVisible = true, formVisible = false, footerVisible = false;
    const updateSticky = () => {
      if (!sticky) return;
      const dialogOpen = !!document.querySelector('dialog[open]');
      const show = mobile.matches && !introVisible && !formVisible && !footerVisible && !dialogOpen;
      sticky.toggleAttribute('data-visible', show); sticky.setAttribute('aria-hidden', String(!show));
      const a = sticky.querySelector('a'); if (a) a.tabIndex = show ? 0 : -1;
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.target === intro) introVisible = e.isIntersecting;
        if (e.target === formSection) formVisible = e.isIntersecting;
        if (e.target === footer) footerVisible = e.isIntersecting;
      }); updateSticky();
    }, { threshold: 0, rootMargin: '0px 0px 30px 0px' });
    [intro, formSection, footer].forEach(el => { if (el) observer.observe(el); });
    on(document, 'close', updateSticky, true);
    on(document, 'dn:dialog-open', updateSticky);
    document.querySelectorAll('dialog').forEach(d => { on(d, 'close', updateSticky); });
    on(mobile, 'change', updateSticky);
    cleanups.push(() => { handlers.forEach(fn => fn()); observer.disconnect(); delete shell.dataset.ready; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', () => { cleanups.splice(0).forEach(fn => fn()); init(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-shell"] && !Shopify.designMode) return;
  try {
    
(() => {
  const cleanups = [];
  function init() {
    const shell = document.querySelector('[data-rp-shell]');
    if (!shell || shell.dataset.ready) return;
    shell.dataset.ready = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const compact = matchMedia('(max-width: 749px)');
    const films = [...document.querySelectorAll('[data-rp-video]')];
    const heroFilms = films.filter(v => v.hasAttribute('data-rp-hero'));
    const visibility = new Map();
    const userPaused = new WeakSet();
    const userStarted = new WeakSet();
    const delivery = new WeakMap();
    const saveData = navigator.connection?.saveData === true;
    const handlers = [];
    const on = (el, event, fn, options) => { if (!el) return; el.addEventListener(event, fn, options); handlers.push(() => el.removeEventListener(event, fn, options)); };
    const resizeObservers = [];
    let stopped = false;
    function state(video) {
      const button = video.parentElement.querySelector('[data-rp-play]');
      if (!button) return;
      button.toggleAttribute('data-playing', !video.paused);
      button.setAttribute('aria-pressed', String(!video.paused));
      button.setAttribute('aria-label', video.paused ? button.dataset.labelPlay : button.dataset.labelPause);
    }
    function selectSource(video, advance = false) {
      let current = delivery.get(video);
      if (!current) {
        const hlsSupported = Boolean(video.canPlayType('application/vnd.apple.mpegurl') || video.canPlayType('application/x-mpegURL'));
        const candidates = [
          { url: video.dataset.src, hls: video.dataset.srcType === 'application/vnd.apple.mpegurl' },
          { url: video.dataset.srcOriginal, hls: false },
          { url: video.dataset.srcFallback, hls: false },
          { url: video.dataset.srcHls, hls: true }
        ];
        const sources = candidates.filter(source => source.url && (!source.hls || hlsSupported)).map(source => source.url);
        current = { sources: [...new Set(sources)], index: 0 };
        const activeIndex = current.sources.indexOf(video.getAttribute('src'));
        if (activeIndex >= 0) current.index = activeIndex;
        delivery.set(video, current);
      }
      if (advance) current.index += 1;
      const url = current.sources[current.index];
      if (!url) return false;
      if (video.getAttribute('src') !== url) { video.src = url; video.load(); }
      return true;
    }
    function play(video) {
      if (stopped || document.hidden) return;
      if (!selectSource(video)) return;
      video.muted = true;
      video.dataset.rpPlayAttempt = String((Number(video.dataset.rpPlayAttempt) || 0) + 1);
      const promise = video.play();
      if (promise) promise.then(() => { video.dataset.rpPlayResult = 'resolved'; }).catch(() => { video.dataset.rpPlayResult = 'rejected'; state(video); });
    }
    function sync() {
      const vis = v => visibility.get(v) || 0;
      const eligible = films.filter(v => vis(v) >= .3 && !userPaused.has(v) && ((!reduced.matches && !saveData) || userStarted.has(v)))
        .sort((a, b) => vis(b) - vis(a));
      const active = new Set();
      const heroEligible = eligible.filter(v => heroFilms.includes(v));
      if (compact.matches && heroEligible.length === 2) {
        heroEligible.forEach(v => active.add(v));
      } else {
        eligible.slice(0, compact.matches ? 1 : 2).forEach(v => active.add(v));
      }
      films.forEach(video => { if (!document.hidden && active.has(video)) { if (video.paused) play(video); } else video.pause(); });
    }
    const observer = new IntersectionObserver(entries => { entries.forEach(e => visibility.set(e.target, e.intersectionRatio)); sync(); }, { threshold: [0, .3, .6, .85, 1] });
    films.forEach(video => {
      observer.observe(video);
      on(video, 'loadeddata', () => video.setAttribute('data-ready', ''));
      on(video, 'play', () => state(video));
      on(video, 'pause', () => state(video));
      on(video, 'error', () => {
        video.removeAttribute('data-ready');
        video.pause();
        state(video);
        if (!stopped && selectSource(video, true)) sync();
      });
      on(video.parentElement.querySelector('[data-rp-play]'), 'click', () => {
        if (video.paused) {
          userPaused.delete(video); userStarted.add(video);
          const isHero = heroFilms.includes(video);
          films.forEach(other => { if (other === video) return; if (isHero && heroFilms.includes(other) && !userPaused.has(other)) return; other.pause(); });
          play(video);
        } else { userPaused.add(video); video.pause(); }
      });
    });
    document.addEventListener('visibilitychange', sync);
    reduced.addEventListener('change', sync);
    compact.addEventListener('change', sync);
    document.querySelectorAll('[data-rp-carousel]').forEach(carousel => {
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('.rp-film-track');
      const previous = carousel.querySelector('[data-rp-prev]');
      const next = carousel.querySelector('[data-rp-next]');
      if (!track || !previous || !next) return;
      const update = () => { previous.disabled = track.scrollLeft <= 3; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3; };
      on(previous, 'click', () => track.scrollBy({ left: -track.clientWidth * .82, behavior: reduced.matches ? 'auto' : 'smooth' }));
      on(next, 'click', () => track.scrollBy({ left: track.clientWidth * .82, behavior: reduced.matches ? 'auto' : 'smooth' }));
      on(track, 'scroll', update, { passive: true });
      const resize = new ResizeObserver(update); resize.observe(track); resizeObservers.push(resize);
      update();
    });
    const formAnchor = document.getElementById(shell.dataset.formAnchor);
    const formSection = formAnchor?.closest('.shopify-section');
    document.querySelectorAll('[data-rp-appointment]').forEach(link => on(link, 'click', event => {
      if (!formSection) return;
      event.preventDefault();
      formSection.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
      const heading = formSection.querySelector('h1,h2,h3,.h2');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
    }));
    const sticky = document.querySelector('[data-rp-sticky]');
    const hero = document.querySelector('.rp-hero');
    let heroPassed = false, formVisible = false, footerVisible = false;
    const updateSticky = () => {
      if (!sticky) return;
      const show = heroPassed && !formVisible && !footerVisible;
      sticky.toggleAttribute('data-visible', show); sticky.setAttribute('aria-hidden', String(!show));
      const a = sticky.querySelector('a'); if (a) a.tabIndex = show ? 0 : -1;
    };
    const stickObserver = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.target === hero) heroPassed = !e.isIntersecting && e.boundingClientRect.bottom < 0;
        if (e.target === formSection) formVisible = e.isIntersecting;
        if (e.target.matches('.shopify-section--footer')) footerVisible = e.isIntersecting;
      }); updateSticky();
    }, { threshold: 0 });
    if (hero) stickObserver.observe(hero);
    if (formSection) stickObserver.observe(formSection);
    const footer = document.querySelector('.shopify-section--footer'); if (footer) stickObserver.observe(footer);
    cleanups.push(() => { stopped = true; handlers.forEach(fn => fn()); resizeObservers.forEach(o => o.disconnect()); observer.disconnect(); stickObserver.disconnect(); films.forEach(v => v.pause()); document.removeEventListener('visibilitychange', sync); reduced.removeEventListener('change', sync); compact.removeEventListener('change', sync); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', () => { cleanups.splice(0).forEach(fn => fn()); const shell = document.querySelector('[data-rp-shell]'); if (shell) delete shell.dataset.ready; init(); });
  window.addEventListener('pagehide', () => document.querySelectorAll('[data-rp-video]').forEach(v => v.pause()));
})();

  } catch(e) { console.error(e); }
})();
})();
